import styled from 'styled-components';
import { smallParagraph, smallSpacedHeading } from '../../../../theme/typography';

export const Row = styled.div`
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
  width: 100%;

  &:not(:first-child) {
    margin-top: 16px;
  }
`;

export const Label = styled.span`
  text-align: left;
  ${smallSpacedHeading};
`;

export const Value = styled.span`
  text-align: right;
  ${smallParagraph};
`;
